import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { connect } from 'react-redux';
import { createDocumentGdrive } from '../actions/documents';
import { tagFunnel } from '../actions/tagmanager';
import { GDRIVE, UPLOAD_OPTIONS_HEADER, UPLOAD_OPTIONS_SUB_HEADER } from '../util/dataTestIds';
import DocumentTextarea from './DocumentTextarea';
import DocumentUploadBtn from './DocumentUploadBtn';
import ErrorMessage from './ErrorMessages';
import { Subheading, PaperUploadUi, ImportPaperCopy, ButtonsWrapper } from './UploadOptions.module.css';
import { CENTER } from '../types';
import { selectDisplayLegal, selectButtonAttributes, selectCollapsed, selectSite } from '../selectors/site';
import { UploadGDriveButton, GoogleDriveIcon, Title } from '../styles';
import { LegalCopy } from '../components/LegalCopy';
import { GOOGLE_DRIVE_BUTTON_COPY, IMPORT_PAPER_COPY, HEADER_DEFAULT_COPY, SUBHEADER_DEFAULT_COPY, GOOGLE_DRIVE_LABEL_COPY } from '../constants';
export var UploadOptions = function UploadOptions(_ref) {
  var openCheckModal = _ref.openCheckModal,
    initialized = _ref.initialized,
    initialCollapsed = _ref.initialCollapsed,
    pasteOnly = _ref.pasteOnly,
    _ref$headingText = _ref.headingText,
    headingText = _ref$headingText === void 0 ? HEADER_DEFAULT_COPY : _ref$headingText,
    _ref$subheadingText = _ref.subheadingText,
    subheadingText = _ref$subheadingText === void 0 ? SUBHEADER_DEFAULT_COPY : _ref$subheadingText,
    _ref$alignText = _ref.alignText,
    alignText = _ref$alignText === void 0 ? CENTER : _ref$alignText,
    displayLegal = _ref.displayLegal,
    buttonAttributes = _ref.buttonAttributes,
    demoTextEnabled = _ref.demoTextEnabled,
    isResubmit = _ref.isResubmit,
    filename = _ref.filename,
    onEnterText = _ref.onEnterText,
    onCtaActivated = _ref.onCtaActivated,
    onCtaClicked = _ref.onCtaClicked,
    onComputerCtaClicked = _ref.onComputerCtaClicked,
    onGoogleDriveCtaClicked = _ref.onGoogleDriveCtaClicked,
    site = _ref.site;
  var hasSubText = subheadingText && subheadingText.length > 0;
  var handleGoogleDriveCTAClick = function handleGoogleDriveCTAClick(e) {
    onGoogleDriveCtaClicked && onGoogleDriveCtaClicked();
    openCheckModal(e);
  };
  return /*#__PURE__*/React.createElement(PaperUploadUi, {
    className: "uw__paper-upload-ui",
    site: site
  }, /*#__PURE__*/React.createElement(Title, {
    className: "uw__title",
    "data-test-id": UPLOAD_OPTIONS_HEADER,
    textAlign: alignText,
    site: site,
    addMarginBottom: !hasSubText
  }, headingText), /*#__PURE__*/React.createElement(Subheading, {
    className: "uw__subheading",
    textAlign: alignText,
    site: site,
    "data-test-id": UPLOAD_OPTIONS_SUB_HEADER
  }, subheadingText), /*#__PURE__*/React.createElement(ErrorMessage, null), /*#__PURE__*/React.createElement("form", {
    className: "uw__form"
  }, /*#__PURE__*/React.createElement(DocumentTextarea, {
    initialized: initialized,
    initialCollapsed: initialCollapsed,
    buttonAttributes: buttonAttributes,
    onEnterText: onEnterText,
    onCtaActivated: onCtaActivated,
    onCtaClicked: onCtaClicked,
    demoTextEnabled: demoTextEnabled,
    isResubmit: isResubmit,
    filename: filename
  }), /*#__PURE__*/React.createElement("div", {
    className: "paper-entry text-center"
  }, !pasteOnly && /*#__PURE__*/React.createElement(ImportPaperCopy, {
    className: "uw__import-paper"
  }, IMPORT_PAPER_COPY), !pasteOnly && /*#__PURE__*/React.createElement(ButtonsWrapper, {
    className: "uw__button-container"
  }, /*#__PURE__*/React.createElement(DocumentUploadBtn, {
    buttonAttributes: buttonAttributes,
    onComputerCtaClicked: onComputerCtaClicked
  }), /*#__PURE__*/React.createElement(UploadGDriveButton, _extends({}, buttonAttributes, {
    className: "uw__gdrive-upload",
    size: "medium",
    "aria-label": GOOGLE_DRIVE_LABEL_COPY,
    disabled: !initialized,
    "data-id": "gDriveUpload",
    "data-test-id": GDRIVE,
    onClick: function onClick(e) {
      return handleGoogleDriveCTAClick(e);
    }
  }), /*#__PURE__*/React.createElement(GoogleDriveIcon, {
    name: "google-drive"
  }), /*#__PURE__*/React.createElement("span", null, GOOGLE_DRIVE_BUTTON_COPY, "\u2122"))))), displayLegal && /*#__PURE__*/React.createElement(LegalCopy, null));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    initialized: state.app.initialized,
    displayLegal: selectDisplayLegal(state),
    site: selectSite(state),
    buttonAttributes: selectButtonAttributes(state),
    initialCollapsed: selectCollapsed(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openCheckModal: function openCheckModal(e) {
      e.preventDefault();
      dispatch(createDocumentGdrive());
      dispatch(tagFunnel('upload paper', 'on google drive'));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UploadOptions);